import useTermsStandard from './useTermsStandard';

import TermButton from '../TermButton';

const TermsStandard: React.FunctionComponent = function () {
  const { terms, gridClassName } = useTermsStandard();
  if (!terms) return null;
  return (
    <>
      <h3 className="text-14-22-b md:text-16-20-b mb-3">
        Select your repayment term
      </h3>
      <div className={gridClassName}>
        {terms.map(({ term, label, key, id, onClick }) => (
          <TermButton
            term={term}
            label={label}
            id={id}
            key={key}
            onClick={onClick}
          />
        ))}
      </div>
    </>
  );
};

export default TermsStandard;
